import React from "react";
import { Autocomplete, Box, Button, Chip, Stack, TextField, Typography } from "@mui/material";
import CommonForm from "../common/CommonForm";
import SkillRankEditPanel from "./SkillRankEditPanel";
import FormContent from "./skillInfoFormSchema";

const PROJECT_OPTIONS = ["steminpe"];

export default function SkillInfoForm({
  formik,
  rankSeed,
  onSubmit,
  submitLabel = "儲存",
}) {
  const updateRank = (rankValue) => {
    formik.setFieldValue("rank_direction", rankValue.rank_direction);
    formik.setFieldValue("skill_rank_male", rankValue.skill_rank_male);
    formik.setFieldValue("skill_rank_female", rankValue.skill_rank_female);
  };

  return (
    <Stack spacing={3}>
      <CommonForm
        fromContent={FormContent}
        formik={formik}
        hideSubmitButton
      />
      <Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          項目可選擇現有代碼，或輸入新的項目代碼。
        </Typography>
        <Autocomplete
          multiple
          freeSolo
          options={PROJECT_OPTIONS}
          value={formik.values.projects || []}
          onChange={(event, newValue) => {
            const projects = newValue
              .map((item) => String(item).trim())
              .filter((item) => item !== "");
            formik.setFieldValue("projects", projects);
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => {
              const { key, ...tagProps } = getTagProps({ index });
              return <Chip key={key} label={option} {...tagProps} />;
            })
          }
          renderInput={(params) => (
            <TextField {...params} label="項目 Project" placeholder="項目代碼" />
          )}
        />
      </Box>
      <SkillRankEditPanel seed={rankSeed} onChange={updateRank} />
      <Box>
        <Button variant="contained" onClick={onSubmit}>
          {submitLabel}
        </Button>
      </Box>
    </Stack>
  );
}
